import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useGuest } from "@/context/GuestContext";
import { http } from "@/lib/api";
import BrandLogo from "@/components/BrandLogo";
import { UtensilsCrossed, Flame, Receipt, MessageCircle, CheckCircle2, LogOut, Sparkles } from "lucide-react";

export default function GuestDashboard() {
  const { guest, stay, logout, loading } = useGuest();
  const nav = useNavigate();
  const [prop, setProp] = useState(null);
  const [contact, setContact] = useState(null);
  useEffect(() => { http.get("/public/property").then((r) => setProp(r.data.property)).catch(() => {}); }, []);
  useEffect(() => { http.get("/guest/portal-contact").then((r) => setContact(r.data)).catch(() => {}); }, []);
  if (loading) return null;
  if (!guest) { nav("/guest/check-in"); return null; }

  const tiles = [
    { to: "/guest/menu", icon: UtensilsCrossed, label: "Order Food & Drinks", sub: "Wood-fired Himachali kitchen" },
    { to: "/guest/services", icon: Flame, label: "Request Service", sub: "Bonfire, heater, BBQ & more" },
    { to: "/guest/orders", icon: Sparkles, label: "My Orders", sub: "Live status of your requests" },
    { to: "/guest/bill", icon: Receipt, label: "My Bill", sub: "Running total & checkout" },
  ];

  return (
    <div className="min-h-screen pb-20" style={{ background: "var(--surface)" }}>
      <div className="max-w-lg mx-auto px-4 pt-8">
        <BrandLogo className="h-11 mb-5" />
        <div className="flex items-start justify-between mb-6">
          <div>
            <div className="eyebrow mb-1">Checked in</div>
            <h1 className="font-serif text-4xl">Welcome, {guest.full_name.split(" ")[0]}</h1>
            <p style={{ color: "var(--muted)" }} className="mt-1 text-sm">{stay.check_in_date} → {stay.check_out_date} · {stay.total_pax} guests</p>
          </div>
          <button data-testid="guest-logout" onClick={logout} className="text-sm flex items-center gap-1" style={{ color: "var(--muted)" }}><LogOut size={14} /> End</button>
        </div>

        <div className="card mb-6" style={{ background: "linear-gradient(135deg, var(--pine) 0%, #1E3227 100%)", color: "#F5F2EC", border: "none" }}>
          <div className="flex items-center gap-2 opacity-80 text-xs uppercase tracking-widest mb-2"><CheckCircle2 size={14} /> Status</div>
          <div className="font-serif text-3xl">Enjoy your stay at Freebird Nest</div>
          {prop?.wifi_name && (
            <p className="opacity-80 mt-2 text-sm">Wi-Fi: <b>{prop.wifi_name}</b> · Password: <b>{prop.wifi_password}</b></p>
          )}
        </div>

        <div className="grid grid-cols-2 gap-4">
          {tiles.map((t) => (
            <Link key={t.to} to={t.to} data-testid={`guest-tile-${t.to.split("/").pop()}`} className="mobile-tile">
              <t.icon size={26} style={{ color: "var(--terracotta)" }} />
              <div className="font-serif text-xl mt-1">{t.label}</div>
              <div className="text-xs" style={{ color: "var(--muted)" }}>{t.sub}</div>
            </Link>
          ))}
        </div>

        <div className="mobile-tile mt-4 flex-row items-center gap-4" data-testid="guest-contact-host">
          <MessageCircle size={22} style={{ color: "var(--terracotta)" }} />
          <div className="flex-1"><div className="font-serif text-lg">Contact Host</div><div className="text-xs" style={{ color: "var(--muted)" }}>Call or WhatsApp anytime</div></div>
          {contact?.phone && (
            <div className="flex gap-2">
              <a data-testid="guest-contact-call" href={`tel:${contact.tel}`} className="btn-outline" style={{ padding: "6px 12px", fontSize: 12 }}>Call</a>
              {contact.whatsapp_digits && (
                <a data-testid="guest-contact-whatsapp" href={`https://wa.me/${contact.whatsapp_digits}`} target="_blank" rel="noreferrer" className="btn-outline" style={{ padding: "6px 12px", fontSize: 12 }}>WhatsApp</a>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
